document.addEventListener("DOMContentLoaded", function () {
  const overlay = document.querySelector(".sparkle-overlay");
  if (!overlay) return;

  setInterval(() => {
    for (let i = 0; i < 3; i++) {
      // 3 sparkles per tick
      const sparkle = document.createElement("div");
      sparkle.className = "sparkle";

      sparkle.style.top = Math.random() * 100 + "%";
      sparkle.style.left = Math.random() * 100 + "%";

      document.querySelector(".sparkle-overlay").appendChild(sparkle);

      setTimeout(() => sparkle.remove(), 1000);
    }
  }, 150); //every .15 sec
});
